import React from "react";
import "./Header.css";
import { Title } from "../../../../components";
import { Container } from "react-bootstrap";
import { useTranslation } from '../../../../contexts/TranslationContext';

const Header = ({ pageData, url }) => {
    const { t } = useTranslation();

  return (
    <div className="packages-list-services-container" data-aos="fade-down" data-aos-duration="1500">
      <Container className="margin-top">
        <Title
          title={pageData?.page_title??""}
          desc={t("DreamVacationDestination")}
          para={pageData?.page_description??""}
        />
      </Container>
    </div>
  );
};

export default Header;
